<template>
  <div class="d-flex justify-content-between" v-if="allItems.length">
    <div class="text-right m-4">
      <h5 style="font-size: 1vw !important"></h5>
    </div>
    <div class="d-flex">
      <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"  v-if="modalMessage &&  allItems.length" @click="modalMessageShowModal=true">   دلایل عدم تایید</a>


<!--      <a :href="`${this.download_url}/KeyActivitiesProblem/all/pdf/${id_route}?token=${$cookies.get('id_login')}`"
         style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1" v-show="false" >خروجی
        PDF

      </a>-->

    </div>

  </div>
  <center>
    <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>دلایل عدم تایید</p>
        <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
      </div>
      <div>
        <div>
          <p>{{modalMessageShow}}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="modalMessageShowModal=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
        </div>
      </div>
    </div>
  </center>
  <div class="table-responsive p-5" style="overflow-x:scroll; ">
    <center v-show="!allItems.length">
      در انتظار تکمیل / بروزرسانی کاربرگ توسط {{$route.params.title}}
    </center>
    <center v-show="status_show">
      <div class="alert alert-success">
        تایید نهایی   شرکت {{$route.params.title}} انجام شد
      </div>
    </center>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

      <table class="table table-striped" v-show="allItems.length" style="width: 140vw; ">
        <tbody>
        <tr style="height: 1vw !important;">
          <th style="width: 1vw;" class="sticky-header">
            <strong >ردیف</strong></th>
          <th class="sticky-header" style="width: 7vw;"><br><strong>اقدام پشتیبان</strong></th>

          <th class="sticky-header" style="width: 3vw;">
            <strong>همسوسازی و ایجاد انگیزه برای متولیان بهره‌وری</strong></th>
          <th style="width: 3vw;" class="sticky-header"><strong>
            همراه‌سازی و هم‌افزایی بازیگران کلیدی  </strong></th>
          <th class="sticky-header" style="width: 3vw;"><br><strong> تبیین و گفتمان‌سازی عمومی </strong></th>
          <th class="sticky-header" style="width: 7vw;"><br><strong> دوره ]چرخه     </strong></th>
          <th class="sticky-header" style="width: 7vw;"><br><strong> میزان پیشرفت اقدام   </strong></th>
          <th class="sticky-header" style="width: 4vw;"><br><strong> هدف(%)   </strong></th>
          <th class="sticky-header" style="width: 4vw;"><strong>میزان انحراف از هدف    </strong></th>
          <th class="sticky-header" style="width: 4vw;"><strong>تاریخ شروع و پایان اقدام    </strong></th>
          <th style="width: 10vw;" class="sticky-header"><strong>  مهمترین موانع عدم تحقق برنامه   </strong></th>
          <th style="width: 10vw;" class="sticky-header"><strong>  راهکار پیشنهادی  </strong></th>

        </tr>
        <tr  class="bg-white" v-for="(item, index) in allItems">
          <td >{{ index + 1 }}</td>
          <td>
            {{  item.title }}
          </td>
          <td>
            {{ item.alignment_and_motivation ? '✅' : '❌' }}
          </td>
          <td>
            {{ item.accompanying_and_synergy ? '✅' : '❌' }}
          </td>
          <td>
            {{ item.explanation_and_discussion ? '✅' : '❌' }}
          </td>
          <td>
            {{ event }}
          </td>


          <td style="width: 7vw; ">
            <input style="text-align: center"
                   @keyup="calculatedValue(item.id)" :value="item.support_action && item.support_action.target_process" :id="`inputOne_${item.id}`" type="number" class="form-control">
          </td>
          <td style="width: 7vw; ">
            <input style="text-align: center"
                   @keyup="calculatedValue(item.id)"  :value="item.support_action && item.support_action.target" :id="`inputTwo_${item.id}`" type="number" class="form-control">
          </td>
          <td style="width: 7vw; ">
            <input
                style="text-align: center"
                disabled
                :value="calculateValue(item.support_action)"
                :id="`inputSeven_${item.id}`"
                type="number"
                class="form-control">
          </td>

          <td>
            {{ item.start_date +' '+ item.end_date }}
          </td>
          <td>
            <input  :value="item.support_action && item.support_action.kfpm" :id="`inputNine_${item.id}`" type="text" class="form-control">
          </td>
          <td>
            <input  :value="item.support_action && item.support_action.proposed_solution" :id="`inputTen_${item.id}`" type="text" class="form-control">
          </td>
        </tr>
        </tbody>
      </table>
  </div>
    <center  v-show="allItems.length">
      <hr class="w-75 my-4">
      <button @click.prevent="store" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>
    </center>
    <hr v-if="allItems.length">
    <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-3">
      <a :href="`${this.download_url}/KeyActivitiesProblem/all/word/${id_route}?token=${$cookies.get('id_login')}`" style="margin-top: 1.3vw;margin-left: 1vw;"
         class="btn btn-primary btn-submit-1">خروجی Word</a>
      <p @click.prevent="exportDocs"   style="margin-left: 1vw;margin-top: 2.5vw;"
         class="btn btn-primary btn-submit-1">خروجی مستندات</p>
      <a
          v-if="false"
          style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green " class="btn btn-primary btn-submit-1 "

            @click="acceptComplete"
      >
        <div v-if="!status_loading">

          <span  >  تایید </span>
        </div>
        <div v-else>
          <div class="loader-line"></div>

        </div>
      </a>
      <a
          v-if="false"
          style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
             @click="acceptComplete2"
      >
        <div v-if="!status_loading2">
          <span >عدم تایید</span>
        </div>

        <div v-else>
          <div class="loader-line"></div>

        </div>
      </a>
    </div>
  </div>
  <center v-show="allItems.length">
    <hr class="w-75 my-1">
  </center>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
    <div class="d-flex justify-content-between">
      <p>{{titleDoc}}</p>
      <p id="btn2_p" @click.prevent="documentsModal=!documentsModal">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" >
      <label class="required text-end">     عنوان مستندات پیوست  </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" >
      <label class="required text-end">      فایل   پیوست  </label>
      <label class="input input--file">

        <input  id="file" type="file" class="input__field" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv" required>
        <span class="input__support">
    <span class="input__helper"></span>
    </span>
      </label>
    </div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2" >
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      <hr class="my-3 w-100" >
    </center>
    <div v-if="!documents.length">موردی یافت نشد!</div>
    <table  class="table table-striped bg-white" v-if="documents.length">
      <thead >
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th  style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.title}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td >
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="importModal">
    <div class="d-flex flex-row justify-content-between">
      <p>درون ریزی</p>
      <p @click="importModal=!importModal">❌</p>
    </div>
    <div style="border: 1px solid #777; padding: 1vw; border-radius: 1vw">
      <input ref="fileInputTwo"  type="file" class="form-control" style="display:block;" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
      <div class="d-flex align-items-center justify-content-center">

      </div>
    </div>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {Vue3PersianDatetimePicker},
  data() {
    return {
      status_loading2: false,
      importModal: false,
      delete_fileModal: false,
      documentsModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      documents: [],
      id: '',
      title: '',
      id_file: '',
      titleDoc: '',
      title_attach: '',
      file: '',
      id_two: '',

      target: '',

      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      key_activities_problems_id: '',
      spring_progress: '',
      summer_progress: '',
      autumn_progress: '',
      winter_progress: '',
      progress: '',
      deviation: '',
      important_obstacles: '',
      approach: '',
      year_funds: '',
      spring_funds: '',
      summer_funds: '',
      autumn_funds: '',
      winter_funds: '',
      id_user: '',
      id_route: this.$route['params']['id'],
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessageShow: '',
      modalMessage: false,
      modalMessageShowModal: false,
      event: '',
    }
  },
  methods: {
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/SupportActionMonitoring/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    acceptComplete(){
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/SupportActionMonitoring/update_complete_by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    importExcel(){
      const file = this.$refs.fileInputTwo.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/import`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInputTwo.value = ''
            this.all()
            this.importModal=false

          })
          .catch();
    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/total_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },

    addDoc(title,id){
      this.id=id
      this.titleDoc=title
      this.allDocsMethod(this.id)
      this.documentsModal=true
    },
    calculateValue(supportAction) {
      if (!supportAction) return "0";
      const { target_process = 0, target = 0 } = supportAction;
      const result = parseInt(target) - parseInt(target_process);
      console.log(result)
      if (result <= 0) {
        return 0;
      }
      return result;
    },
    calculatedValue(id){
      let result = 0
      const one = document.querySelector(`#inputTwo_${id}`).value
      const two = document.querySelector(`#inputOne_${id}`).value
      let calc = one-two
      if (calc<0){
        result=0
        document.querySelector(`#inputSeven_${id}`).value = result
        return
      }
      result=calc
      document.querySelector(`#inputSeven_${id}`).value = result

    },



    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },


    all() {
      this.modalMessage = false

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems = Object.values(response.all)
            this.event = response.event
            if (response.message){
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
          })
          .catch();
    },
    store() {
      let obj = []
      this.allItems.forEach((item) => {
        const inputOne= document.getElementById(`inputOne_${item.id}`).value
        const inputTwo = document.getElementById(`inputTwo_${item.id}`).value
        const inputSeven = document.getElementById(`inputSeven_${item.id}`).value
        const inputNine = document.getElementById(`inputNine_${item.id}`).value
        const inputTen = document.getElementById(`inputTen_${item.id}`).value





        let record = {
          'q_id': item.id,
          'target_process': inputOne,
          'target':inputTwo,
          'deviation': inputSeven,
          'kfpm':inputNine,
          'proposed_solution':inputTen,
          'id': item.support_action ? item.support_action.id  : null

        }
        obj.push(record)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      formdata.append('company_id',this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/SupportActionMonitoring/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

          })
          .catch();
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
  },
  mounted() {
    this.all()
    this.fetchItems()
  }
}
</script>
<style scoped>
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}
.input:hover .input__support {
  border-color: #9fa8b2;
}
.input:hover .input__support:before {
  color: #7d8a96;
}
.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}
.input__text sup {
  color: #fe4f3e;
  cursor: help;
}
.input .input__support:before {
  display: none;

}
.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__field:focus + .input__support {
  border-color: #037DE4;
}
.input__field:valid + .input__support {
  border-color: #3742FA;
}
.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}
.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}
.input__field:invalid + .input__support:before {
  content: "file_upload";
}
.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}
.input__support {
  display: flex !important;
  align-items: center;
}
.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}
.input--file {
  cursor: pointer;
}
.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
</style>
